import { useEffect, useRef } from 'react';
import { Terminal, Trash2 } from 'lucide-react';

type Props = {
  logs: string[];
  onClear?: () => void;
};

export const StatusLog = ({ logs, onClear }: Props) => {
  const logRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (logRef.current) {
      logRef.current.scrollTop = -logRef.current.scrollHeight;
    }
  }, [logs]);

  return (
    <div className="w-full max-w-2xl mx-auto bg-white border border-slate-200 rounded-2xl p-6 shadow-xl space-y-4">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2 text-slate-800 font-semibold text-lg">
          <Terminal className="w-5 h-5" />
          Agent Logs
        </div>

        {logs.length > 0 && onClear && (
          <button
            onClick={onClear}
            className="flex items-center gap-1 text-xs text-red-500 hover:text-red-600 transition"
          >
            <Trash2 className="w-4 h-4" />
            Clear Logs
          </button>
        )}
      </div>

      <div
        ref={logRef}
        className="h-64 overflow-y-auto pr-2 text-sm font-mono text-emerald-600 space-y-1 scrollbar-thin scrollbar-thumb-indigo-300 scrollbar-track-transparent"
      >
        {logs.length === 0 ? (
          <p className="text-slate-400 italic">No mining activity yet...</p>
        ) : (
          logs.map((log, idx) => (
            <div key={idx} className="whitespace-pre-line">
              {log}
            </div>
          ))
        )}
      </div>
    </div>
  );
};
